<template>
  <b-card>
    <b-row class="my-2">
      <h3 class="text-black ml-1">
        <strong>
          Monitoring Claim
        </strong>
        <span
          id="information-claims"
          class="k-info-circle text-info cursor-pointer"
        />
        <b-tooltip
          target="information-claims"
          placement="bottom"
        >
          <div class="mb-1 text-start">
            Kebijakan Claim Ganti Rugi di Komship
          </div>
          <div class="text-start">
            <a
              class="text-info underline"
              href="https://bantuan.komerce.id/id/article/panduan-claim-ganti-rugi-di-komship-1z2sd1/"
              target="_blank"
            >Pelajari lebih lanjut</a>
          </div>
        </b-tooltip>
      </h3>
    </b-row>

    <CardMonitoring />
    <ListMonitoring />
  </b-card>
</template>

<script>
import CardMonitoring from './components/CardMonitoring.vue'
import ListMonitoring from './components/ListMonitoring.vue'

export default {
  components: {
    CardMonitoring,
    ListMonitoring,
  },
}
</script>
